import React from 'react';
import styled from '@emotion/styled';
import { Logo } from '../../components';
import { useUrlForPageId } from '../../../app/pages/ui/utils/useUrlForPageId';
import { PassengersPageId } from '../../../app/pages/domain/constants/PageId';

export const StyledNavigationLogo = styled.div`
	margin: 0;
	line-height: 0;

	a {
		display: inline-block;
		padding: 0;
		text-decoration: none;
	}

	img {
		display: block;
	}
`;

export const NavigationLogo = () => {
	const url = useUrlForPageId(PassengersPageId.Home);

	return (
		<StyledNavigationLogo>
			<a href={url}>
				<Logo />
			</a>
		</StyledNavigationLogo>
	);
};
